import { HttpClient } from '@opallabs/api'
import setCSVCreated from '../setCSVCreated'

const subParamRegex = /sub=([^&]*)/
const getSubParam = () => window.location.search.match(subParamRegex)
const getSubdomain = () => {
  const subParam = getSubParam()

  if (subParam) {
    return `?sub=${subParam[1]}`
  }

  return ''
}

const createCSV = (params) => (dispatch) =>
  HttpClient()
    .post(`/csv_exports${getSubdomain()}`, params)
    .then(() => dispatch(setCSVCreated({ created: true })))

export default createCSV
